/* tool-wall-art-size.js — Wall Art Size Calculator (Art & See).
 * ST(hash) -> compute() -> two views of one answer, no "Calculate" button.
 *   ROOM     a calibrated photograph (assets/tools-room-render.js) with a REAL painting
 *            from the catalogue at the recommended size: px = inches * ppi * (cssW/1024).
 *   MEASURED a dimensioned elevation: floor, ceiling, skirting, a single-weight furniture
 *            outline, dimension lines with terminators and the value inside a gap in the line.
 * Sizing (unchanged, it is the product): w = furniture*{.56|.66|.76} (open wall *{.46|.58|.72}),
 * w<=.90*furniture or .86*wall; h = w*ratio (p1.25|h.80|s1); h<=.52*ceiling; every option is a
 * size we paint. Centre 57-60 in but rises over tall furniture; hook = centre + h/2 - 3 in.
 * Data: window.ArtSeeCatalog; without it, [data-wsz-fallback] (real products).
 */
(function () {
  'use strict';

  var SLUG = 'wall-art-size-calculator';
  var root = document.querySelector('[data-wsz]');
  if (!root) return;

  // 3 conjuntos reais de 7 tamanhos (35.671 obras).
  var SETS = {
    p: [[16, 20], [20, 24], [24, 30], [30, 40], [36, 48], [40, 60], [48, 72]],
    h: [[20, 16], [24, 20], [30, 24], [40, 30], [48, 36], [60, 40], [72, 48]],
    s: [[16, 16], [20, 20], [24, 24], [30, 30], [36, 36], [48, 48], [60, 60]]
  };
  var ORIENT = { p: 'v', h: 'h', s: 's' }, SET_ID = { p: 0, h: 1, s: 2 };  // contrato do indice
  var RATIO = { p: 1.25, h: 0.8, s: 1 };
  var OLBL = { p: 'Portrait', h: 'Landscape', s: 'Square' };

  // largura padrao (in) + folga acima do movel + altura tipica do movel
  var BELOW = {
    sofa: { label: 'Sofa', w: 84, gap: [8, 10], top: 32, o: 'h', art: 'sofa' },
    queen: { label: 'Queen bed', w: 60, gap: [6, 8], top: 48, o: 'h', art: 'bed' },
    king: { label: 'King bed', w: 76, gap: [6, 8], top: 48, o: 'h', art: 'bed' },
    full: { label: 'Full bed', w: 54, gap: [6, 8], top: 48, o: 'h', art: 'bed' },
    fireplace: { label: 'Fireplace', w: 54, gap: [6, 12], top: 48, o: 'h', art: 'mantel' },
    console: { label: 'Console / sideboard', w: 60, gap: [6, 12], top: 32, o: 'h', art: 'console' },
    open: { label: 'Open wall', w: 120, gap: null, top: 0, o: 'p', art: 'none' }
  };
  /* each choice owns a calibrated room plus a wider one for when the statement size
     does not fit the first; ppi, wall and anchor all come from tools-room-render.js */
  var SCENE_FOR = {
    sofa: ['sofa-wall', 'living-room'],
    queen: ['master-bedroom', 'minimal-bedroom'],
    king: ['master-bedroom', 'minimal-bedroom'],
    full: ['master-bedroom', 'minimal-bedroom'],
    fireplace: ['fireplace', 'living-room'],
    console: ['entryway', 'living-room'],
    open: ['gallery-room', 'dining-room']
  };
  var EFFECT = {
    furniture: { subtle: 0.56, balanced: 0.66, statement: 0.76 },
    wall: { subtle: 0.46, balanced: 0.58, statement: 0.72 }
  };
  var PICKS = ['subtle', 'balanced', 'statement'];
  var PICK_LABEL = { subtle: 'Subtle', balanced: 'Balanced', statement: 'Statement' };

  var ST = { below: 'sofa', w: 84, u: 'in', c: 9, o: 'h', pick: 'balanced', style: '' };
  var META = null, CAT_ROWS = null, SEED = 1, FIRST = true;
  var VIEW = 'room';                                   // 'room' | 'draw' (not hash state)
  var ART = { i: 0, row: null, raw: null, url: '', ok: true };
  var ROWS = { k: '', rows: null, live: false };
  var LASTROOM = null, RESIZE = null;

  function readHash() {
    var h = (location.hash || '').replace(/^#/, '');
    if (!h) return;
    h.split('&').forEach(function (kv) {
      var i = kv.indexOf('='); if (i < 0) return;
      var k = decodeURIComponent(kv.slice(0, i)), v = decodeURIComponent(kv.slice(i + 1));
      if (k === 'below' && BELOW[v]) ST.below = v;
      else if (k === 'w') { var n = parseFloat(v); if (isFinite(n) && n > 0) ST.w = n; }
      else if (k === 'u' && (v === 'in' || v === 'cm')) ST.u = v;
      else if (k === 'c') { var c = parseInt(v, 10); if (c === 8 || c === 9 || c === 10) ST.c = c; }
      else if (k === 'o' && RATIO[v]) ST.o = v;
      else if (k === 'pick' && PICK_LABEL[v]) ST.pick = v;
      else if (k === 'style') ST.style = v;
    });
  }
  function writeHash() {
    var s = 'below=' + ST.below + '&w=' + round1(ST.w) + '&u=' + ST.u + '&c=' + ST.c +
      '&o=' + ST.o + '&pick=' + ST.pick + (ST.style ? '&style=' + encodeURIComponent(ST.style) : '');
    try { history.replaceState(null, '', location.pathname + location.search + '#' + s); }
    catch (e) { location.hash = s; }
  }

  function round1(n) { return Math.round(n * 10) / 10; }
  function inFromState() { return ST.u === 'cm' ? ST.w / 2.54 : ST.w; }
  function cm(n) { return Math.round(n * 2.54 * 10) / 10; }
  function clampN(v, a, b) { return v < a ? a : v > b ? b : v; }
  function sizeLabel(sz) { return sz[0] + '" × ' + sz[1] + '"'; }
  function sizeLabelCm(sz) { return cm(sz[0]) + ' × ' + cm(sz[1]) + ' cm'; }
  function uv(inches) { return ST.u === 'cm' ? Math.round(inches * 2.54) + ' cm' : Math.round(inches) + ' in'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) { return '$' + (n >= 100 ? Math.round(n) : (Math.round(n * 100) / 100)); }
  function track(ev, params) {
    var p = params || {}; p.tool = SLUG;
    try {
      if (window.ArtSeeCatalog && window.ArtSeeCatalog.track) window.ArtSeeCatalog.track(ev, p);
      else { window.dataLayer = window.dataLayer || []; p.event = ev; window.dataLayer.push(p); }
    } catch (e) { }
  }

  function nearestIdx(list, target, allowed) {
    var best = allowed[0], bd = Infinity;
    for (var i = 0; i < allowed.length; i++) {
      var d = Math.abs(list[allowed[i]][0] - target);
      if (d < bd) { bd = d; best = allowed[i]; }
    }
    return best;
  }

  function compute() {
    var b = BELOW[ST.below], isWall = ST.below === 'open';
    var anchor = Math.max(12, Math.min(400, inFromState()));
    var ratio = RATIO[ST.o], ceil = ST.c * 12, maxH = ceil * 0.52;
    var eff = EFFECT[isWall ? 'wall' : 'furniture'];
    var set = SETS[ST.o];
    // teto: 86% da parede (open wall) ou 90% do movel — nada transborda o que esta embaixo.
    var wCap = isWall ? anchor * 0.86 : anchor * 0.90;

    var raw = {};
    PICKS.forEach(function (k) {
      var w = anchor * eff[k];
      if (w > wCap) w = wCap;
      var h = w * ratio;
      if (h > maxH) { h = maxH; w = h / ratio; }
      raw[k] = { w: w, h: h };
    });

    var allowed = [];
    for (var i = 0; i < set.length; i++) if (set[i][1] <= maxH && set[i][0] <= wCap) allowed.push(i);
    var capped = allowed.length < set.length;
    if (!allowed.length) allowed = [0];

    var iS = nearestIdx(set, raw.subtle.w, allowed);
    var iB = nearestIdx(set, raw.balanced.w, allowed);
    var iT = nearestIdx(set, raw.statement.w, allowed);
    var lo = allowed[0], hi = allowed[allowed.length - 1];
    // tres opcoes = tres tamanhos: empurra para fora; se nao couber, colapsa para baixo
    if (iT <= iB) iT = Math.min(iB + 1, hi);
    if (iS >= iB) iS = Math.max(iB - 1, lo);
    if (iT === iB) { iB = Math.max(iB - 1, lo); iS = Math.max(iB - 1, lo); }
    if (iS === iB) { iB = Math.min(iB + 1, hi); iT = Math.min(Math.max(iT, iB + 1), hi); }

    var out = {
      anchor: anchor, isWall: isWall, below: b, maxH: maxH, ceil: ceil, capped: capped, options: {},
      // altura estrangulou a largura?
      starved: set[iB][0] < raw.balanced.w * 0.75,
      tooSmall: wCap < set[0][0]
    };
    var idx = { subtle: iS, balanced: iB, statement: iT };
    PICKS.forEach(function (k) {
      var sz = set[idx[k]], h = sz[1];
      var center, gap = null, aboveRule = false;
      if (isWall) { center = 58; }
      else {
        // 57–60 in e regra de parede livre; acima de cabeceira de 48 in ela poria o quadro no movel
        var gapMid = (b.gap[0] + b.gap[1]) / 2;
        center = Math.max(57, b.top + gapMid + h / 2);
        if (center + h / 2 > ceil - 6) center = Math.max(57, ceil - 6 - h / 2);  // respiro no teto
        gap = center - h / 2 - b.top;
        aboveRule = center > 60.5;
      }
      out.options[k] = {
        key: k, size: sz, idx: idx[k], raw: raw[k],
        pct: Math.round(sz[0] / anchor * 100),
        center: center, gap: gap, aboveRule: aboveRule,
        hook: center + h / 2 - 3
      };
    });
    return out;
  }

  /* ------------------------------------------------- the measured elevation
     Drawn in real pixels: the viewBox is regenerated at the measured width of its
     container, so a 1 px line is 1 px and 12 px type is 12 px. Fixed margins on all
     four sides mean no dimension can ever reach an edge. */
  function elevation(R, W) {
    var o = R.options[ST.pick], sz = o.size, b = R.below, ceil = R.ceil;
    W = Math.round(Math.max(W || 720, 300));
    var H = Math.round(clampN(W * 0.62, 320, 560));
    var sml = W < 580;
    var M = { l: sml ? 58 : 104, r: sml ? 64 : 122, t: sml ? 28 : 42, b: sml ? 50 : 70 };
    var iw = W - M.l - M.r, ih = H - M.t - M.b;
    var sceneIn = Math.max(R.anchor * (R.isWall ? 1.08 : 1.5), sz[0] * 1.7, 84);
    var k = Math.min(iw / sceneIn, ih / ceil);
    var drawW = sceneIn * k;
    var x0 = M.l + (iw - drawW) / 2, yF = M.t + ih;
    var cIn = sceneIn / 2;
    var FS = sml ? 10 : 12, LS = sml ? 8 : 9;
    var P = [];
    function n(v) { return Math.round(v * 10) / 10; }
    function X(i) { return x0 + i * k; }
    function Y(i) { return yF - i * k; }
    function xp(i) { return n(X(i)); }
    function yp(i) { return n(Y(i)); }
    function ln(x1, y1, x2, y2, c) { P.push('<line x1="' + n(x1) + '" y1="' + n(y1) + '" x2="' + n(x2) + '" y2="' + n(y2) + '" class="wsz-e__' + c + '"/>'); }
    function pa(d, c) { P.push('<path d="' + d + '" class="wsz-e__' + c + '"/>'); }
    function tp(x, y, c, a, s, size) { P.push('<text x="' + n(x) + '" y="' + n(y) + '" class="wsz-e__' + c + '" font-size="' + size + '"' + (a ? ' text-anchor="' + a + '"' : '') + '>' + esc(s) + '</text>'); }
    function tw(s, size) { return String(s).length * size * 0.56; }
    function arw(x, y, dx, dy) {
      var a = sml ? 5 : 7, t = 2.4;
      if (dx) pa('M' + n(x) + ' ' + n(y) + 'L' + n(x + dx * a) + ' ' + n(y - t) + 'M' + n(x) + ' ' + n(y) + 'L' + n(x + dx * a) + ' ' + n(y + t), 'ar');
      else pa('M' + n(x) + ' ' + n(y) + 'L' + n(x - t) + ' ' + n(y + dy * a) + 'M' + n(x) + ' ' + n(y) + 'L' + n(x + t) + ' ' + n(y + dy * a), 'ar');
    }
    /* a dimension is: two extension lines leaving the object, one line with a
       terminator at each end, and the value sitting IN A GAP in that line */
    function dimH(x1, x2, yd, yObj, val) {
      var s = yd < yObj ? -1 : 1;
      ln(x1, yObj + 3 * s, x1, yd + 7 * s, 'ext');
      ln(x2, yObj + 3 * s, x2, yd + 7 * s, 'ext');
      var g = tw(val, FS) / 2 + 7, m = (x1 + x2) / 2;
      if (x2 - x1 > g * 2 + 18) {
        ln(x1, yd, m - g, yd, 'dim'); ln(m + g, yd, x2, yd, 'dim');
        tp(m, yd + FS * 0.35, 'v', 'middle', val, FS);
      } else {
        ln(x1, yd, x2, yd, 'dim');
        tp(x2 + 7, yd + FS * 0.35, 'v', 'start', val, FS);
      }
      arw(x1, yd, 1, 0); arw(x2, yd, -1, 0);
    }
    function dimV(yTop, yBot, xd, xObj, val, lab) {
      var s = xd < xObj ? -1 : 1;
      ln(xObj + 3 * s, yTop, xd + 7 * s, yTop, 'ext');
      ln(xObj + 3 * s, yBot, xd + 7 * s, yBot, 'ext');
      var need = (lab ? FS + LS + 5 : FS + 3), m = (yTop + yBot) / 2, g = need / 2;
      if (yBot - yTop > need + 18) {
        ln(xd, yTop, xd, m - g, 'dim'); ln(xd, m + g, xd, yBot, 'dim');
        if (lab) { tp(xd, m - g + LS, 'l', 'middle', lab, LS); tp(xd, m + g - 2, 'v', 'middle', val, FS); }
        else tp(xd, m + FS * 0.35, 'v', 'middle', val, FS);
      } else {
        ln(xd, yTop, xd, yBot, 'dim');
        tp(xd + s * 7, m + FS * 0.35, 'v', s < 0 ? 'end' : 'start', val, FS);
      }
      arw(xd, yTop, 0, 1); arw(xd, yBot, 0, -1);
    }

    /* --- the room itself: floor, ceiling, skirting. A wall with no floor under it
       is the placeholder look the old drawing had. */
    ln(x0, Y(ceil), x0 + drawW, Y(ceil), 'ceil');
    tp(x0 + drawW, Y(ceil) - 6, 'l', 'end', (ST.c === 10 ? '10+' : ST.c) + ' FT CEILING', LS);
    ln(x0, yF, x0 + drawW, yF, 'floor');
    ln(x0, Y(4.5), x0 + drawW, Y(4.5), 'skirt');

    /* --- furniture: one weight, no fill, traced from the scene photographs --- */
    if (!R.isWall) {
      var Wf = R.anchor, a0 = cIn - Wf / 2, a1 = cIn + Wf / 2, t = b.top;
      if (b.art === 'sofa') {
        var arm = Math.min(9, Wf * 0.12), seat = Math.max(15, t * 0.5), armT = Math.max(seat + 5, t * 0.72);
        pa('M' + xp(a0) + ' ' + yp(5) + 'V' + yp(armT) + 'H' + xp(a0 + arm) + 'V' + yp(t) + 'H' + xp(a1 - arm) + 'V' + yp(armT) + 'H' + xp(a1) + 'V' + yp(5) + 'Z', 'furn');
        pa('M' + xp(a0 + arm) + ' ' + yp(seat) + 'H' + xp(a1 - arm), 'furn');
        pa('M' + xp(cIn) + ' ' + yp(seat) + 'V' + yp(t - 1.5), 'furn');
        pa('M' + xp(a0 + 3) + ' ' + yp(5) + 'L' + xp(a0 + 2) + ' ' + yp(0), 'furn');
        pa('M' + xp(a1 - 3) + ' ' + yp(5) + 'L' + xp(a1 - 2) + ' ' + yp(0), 'furn');
      } else if (b.art === 'bed') {
        var mt = 26, mb = 15, bs = 7, pw = (Wf - 18) / 2 - 2;
        pa('M' + xp(a0) + ' ' + yp(mt) + 'V' + yp(t - 3) + 'Q' + xp(a0) + ' ' + yp(t) + ' ' + xp(a0 + 3) + ' ' + yp(t) +
          'H' + xp(a1 - 3) + 'Q' + xp(a1) + ' ' + yp(t) + ' ' + xp(a1) + ' ' + yp(t - 3) + 'V' + yp(mt), 'furn');
        pa('M' + xp(a0 + 2) + ' ' + yp(mt) + 'H' + xp(a1 - 2) + 'V' + yp(mb) + 'H' + xp(a0 + 2) + 'Z', 'furn');
        pa('M' + xp(a0 + 5) + ' ' + yp(mb) + 'V' + yp(bs) + 'H' + xp(a1 - 5) + 'V' + yp(mb), 'furn');
        pa('M' + xp(a0 + 7) + ' ' + yp(mt) + 'Q' + xp(a0 + 7 + pw / 2) + ' ' + yp(mt + 10) + ' ' + xp(a0 + 7 + pw) + ' ' + yp(mt), 'furn');
        pa('M' + xp(a1 - 7 - pw) + ' ' + yp(mt) + 'Q' + xp(a1 - 7 - pw / 2) + ' ' + yp(mt + 10) + ' ' + xp(a1 - 7) + ' ' + yp(mt), 'furn');
        pa('M' + xp(a0 + 7) + ' ' + yp(bs) + 'V' + yp(0), 'furn');
        pa('M' + xp(a1 - 7) + ' ' + yp(bs) + 'V' + yp(0), 'furn');
      } else if (b.art === 'mantel') {
        pa('M' + xp(a0 - 4) + ' ' + yp(t) + 'H' + xp(a1 + 4) + 'V' + yp(t - 2.5) + 'H' + xp(a0 - 4) + 'Z', 'furn');
        pa('M' + xp(a0) + ' ' + yp(0) + 'V' + yp(t - 2.5) + 'H' + xp(a1) + 'V' + yp(0), 'furn');
        pa('M' + xp(a0 + 8) + ' ' + yp(2.5) + 'V' + yp(t - 13) + 'H' + xp(a1 - 8) + 'V' + yp(2.5), 'furn');
        pa('M' + xp(a0 - 7) + ' ' + yp(2.5) + 'H' + xp(a1 + 7), 'furn');
      } else {
        pa('M' + xp(a0) + ' ' + yp(t) + 'H' + xp(a1) + 'V' + yp(t - 1.6) + 'H' + xp(a0) + 'Z', 'furn');
        pa('M' + xp(a0 + 2) + ' ' + yp(t - 1.6) + 'V' + yp(t - 8) + 'H' + xp(a1 - 2) + 'V' + yp(t - 1.6), 'furn');
        pa('M' + xp(cIn) + ' ' + yp(t - 1.6) + 'V' + yp(t - 8), 'furn');
        pa('M' + xp(a0 + 9) + ' ' + yp(t - 8) + 'L' + xp(a0 + 10) + ' ' + yp(0), 'furn2');
        pa('M' + xp(a1 - 9) + ' ' + yp(t - 8) + 'L' + xp(a1 - 10) + ' ' + yp(0), 'furn2');
        pa('M' + xp(a0 + 2.5) + ' ' + yp(t - 8) + 'L' + xp(a0 + 3.5) + ' ' + yp(0), 'furn');
        pa('M' + xp(a1 - 2.5) + ' ' + yp(t - 8) + 'L' + xp(a1 - 3.5) + ' ' + yp(0), 'furn');
      }
    }

    /* --- eye level, only when the answer is not already eye level --- */
    if (Math.abs(o.center - 57) > 5) {
      ln(x0, Y(57), x0 + drawW, Y(57), 'eye');
      tp(x0 + 2, Y(57) - 5, 'l', 'start', '57 IN EYE LEVEL', LS);
    }

    /* --- the piece: the only black thing in the drawing --- */
    var pw2 = sz[0] * k, ph2 = sz[1] * k;
    var pL = X(cIn - sz[0] / 2), pT = Y(o.center + sz[1] / 2);
    P.push('<rect x="' + n(pL) + '" y="' + n(pT) + '" width="' + n(pw2) + '" height="' + n(ph2) + '" class="wsz-e__artbg"/>');
    if (ART.url && ART.ok) {
      P.push('<clipPath id="wsz-ec"><rect x="' + n(pL) + '" y="' + n(pT) + '" width="' + n(pw2) + '" height="' + n(ph2) + '"/></clipPath>');
      P.push('<image href="' + esc(ART.url) + '" x="' + n(pL) + '" y="' + n(pT) + '" width="' + n(pw2) + '" height="' + n(ph2) +
        '" preserveAspectRatio="xMidYMid slice" clip-path="url(#wsz-ec)"/>');
    }
    P.push('<rect x="' + n(pL) + '" y="' + n(pT) + '" width="' + n(pw2) + '" height="' + n(ph2) + '" class="wsz-e__art"/>');

    /* --- dimensions --- */
    dimH(pL, pL + pw2, pT - (sml ? 16 : 22), pT, uv(sz[0]));
    dimV(pT, pT + ph2, pL + pw2 + (sml ? 16 : 22), pL + pw2, uv(sz[1]));
    dimV(Y(o.center), yF, M.l / 2, pL, uv(o.center), 'CENTRE');
    dimV(Y(o.hook), yF, W - M.r / 2, pL + pw2, uv(o.hook), 'HOOK');
    if (!R.isWall && o.gap != null && o.gap > 0) {
      dimV(Y(o.center - sz[1] / 2), Y(b.top), pL - (sml ? 14 : 20), pL, uv(o.gap));
    }
    dimH(X(cIn - R.anchor / 2), X(cIn + R.anchor / 2), yF + (sml ? 22 : 30), yF, uv(R.anchor));
    tp(X(cIn), yF + (sml ? 38 : 50), 'l', 'middle', (R.isWall ? 'Wall width' : R.below.label).toUpperCase(), LS);

    return '<svg class="wsz-e" viewBox="0 0 ' + W + ' ' + H + '" width="' + W + '" height="' + H + '" role="img" aria-label="Dimensioned elevation: a ' +
      sizeLabel(sz) + ' painting centred ' + Math.round(o.center) + ' inches from the floor' +
      (R.isWall ? ' on an open wall' : ' above a ' + R.below.label.toLowerCase()) + ', under a ' + (ST.c === 10 ? '10 foot' : ST.c + ' foot') + ' ceiling.">' +
      P.join('') + '</svg>';
  }

  /* ------------------------------------------------------------ catalogue */
  function normalize(r) {
    if (Array.isArray(r)) {
      return {
        handle: r[0], title: r[1], artist: r[2], price: +r[4] || 0,
        style: r[5] || '', orient: r[8], sizeSet: r[9], img: r[10] || ''
      };
    }
    return { handle: r.h, title: r.t, artist: r.a, price: +r.p || 0, style: r.y || '', orient: r.e, sizeSet: r.z, img: r.img || '' };
  }
  function imageUrl(row, raw, width) {
    if (window.ArtSeeCatalog && window.ArtSeeCatalog.imageUrl && Array.isArray(raw)) {
      try { return window.ArtSeeCatalog.imageUrl(raw, width); } catch (e) { }
    }
    var u = row.img || '';
    // o fallback do Liquid ja vem absoluto (e as vezes protocolo-relativo //cdn...)
    if (!/^(https?:)?\/\//.test(u)) u = ((META && META.imgBase) || 'https://art-and-see.com/cdn/shop/files/') + u;
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function pdpUrl(row, raw, sz) {
    if (window.ArtSeeCatalog && window.ArtSeeCatalog.pdpUrl && Array.isArray(raw)) {
      try { return window.ArtSeeCatalog.pdpUrl(raw, { size: sz[0] + 'x' + sz[1] }); } catch (e) { }
    }
    return '/products/' + row.handle + '#size=' + sz[0] + 'x' + sz[1];
  }

  function fallbackRows() {
    if (CAT_ROWS) return CAT_ROWS;
    var el = root.querySelector('[data-wsz-fallback]');
    CAT_ROWS = [];
    if (el) { try { CAT_ROWS = JSON.parse(el.textContent) || []; } catch (e) { CAT_ROWS = []; } }
    return CAT_ROWS;
  }

  /* one list per orientation+seed+style for the room, the thumbnails and the grid:
     three renders of one state must not hit the index three times */
  function getRows(cb) {
    var orient = ORIENT[ST.o], setId = SET_ID[ST.o];
    var key = orient + '|' + setId + '|' + SEED + '|' + (ST.style || '');
    if (ROWS.k === key && ROWS.rows) { cb(ROWS.rows, ROWS.live); return; }
    var keep = function (rows, live) { ROWS = { k: key, rows: rows, live: live }; cb(rows, live); };
    var C = window.ArtSeeCatalog;
    if (C && C.filter) {
      Promise.resolve(C.filter({ orientation: orient, sizeSet: setId, style: ST.style || undefined, limit: 12, seed: SEED }))
        .then(function (rows) {
          if (rows && rows.length) keep(rows, true);
          else keep(localPick(orient, setId), false);
        })
        .catch(function () { keep(localPick(orient, setId), false); });
      return;
    }
    keep(localPick(orient, setId), false);
  }
  function localPick(orient) {
    var all = fallbackRows().filter(function (r) { return r.e === orient; });
    if (ST.style) {
      var f = all.filter(function (r) { return (r.y || '').toLowerCase() === ST.style.toLowerCase(); });
      if (f.length >= 4) all = f;
    }
    var s = SEED >>> 0;
    var scored = all.map(function (r, i) { var x = (i + 1) * 2654435761 ^ s; x = (x ^ (x >>> 13)) >>> 0; return { r: r, x: x }; });
    scored.sort(function (a, b) { return a.x - b.x; });
    return scored.slice(0, 12).map(function (o) { return o.r; });
  }

  /* ----------------------------------------------------------------- room */
  // No photograph in the library shows a painting above a mantel: the calibrated
  // `fireplace` scene is a lit alcove with the hearth on the left wall, a different
  // plane. Showing it to someone who answered "Fireplace" would put the piece NEXT to
  // the fire, not over it, so that answer gets the measured drawing instead, which
  // draws a real mantel. Delete this the day a calibrated mantel photo exists.
  var NO_PHOTO_FOR = { fireplace: 'We do not have a photograph of a painting over a mantel yet, so this one is the measured drawing. The sizes and heights below are the same either way.' };

  function pickScene(R) {
    var RM = window.ArtSeeRoom;
    if (!RM) return null;
    if (NO_PHOTO_FOR[ST.below]) return null;
    // the statement size decides, so all three options share one photograph
    var big = R.options.statement.size[0];
    var ids = SCENE_FOR[ST.below] || ['gallery-room'];
    for (var i = 0; i < ids.length; i++) {
      var sc = RM.sceneById(ids[i]);
      if (sc && RM.wallWidthIn(sc) >= big + 8) return sc;
    }
    return RM.sceneById('gallery-room') || RM.sceneById(ids[0]);
  }

  function roomOff(msg) {
    ART.ok = false;
    root.classList.add('wsz--noroom');
    if (VIEW === 'room') { VIEW = 'draw'; syncView(); }
    var note = root.querySelector('[data-wsz-roomnote]');
    if (note) note.textContent = msg || '';
  }

  function renderRoom(R) {
    var cv = root.querySelector('[data-wsz-canvas]');
    var box = root.querySelector('[data-wsz-stage]');
    var RM = window.ArtSeeRoom;
    if (!cv || !box || !RM) { roomOff('The room view needs JavaScript that did not load. The measured drawing below is complete.'); return; }
    var o = R.options[ST.pick], sc = pickScene(R);
    if (!sc) {
      // No photograph for this answer, but the elevation still hangs a real painting:
      // an empty frame in a drawing on a shop that sells paintings is the defect this
      // whole rebuild set out to remove. Fetch the art, skip only the room.
      roomOff(NO_PHOTO_FOR[ST.below] || '');
      getRows(function (rows) {
        if (!rows || !rows.length) return;
        var raw0 = rows[ART.i % rows.length];
        ART.raw = raw0; ART.row = normalize(raw0); ART.url = imageUrl(ART.row, raw0, 700);
        ART.ok = true;                       // roomOff cleared it; the drawing still wants the art
        var svg0 = root.querySelector('[data-wsz-svg]');
        if (svg0) svg0.innerHTML = elevation(R, svg0.clientWidth || 720);
      });
      return;
    }
    getRows(function (rows) {
      if (!rows || !rows.length) { roomOff('No painting to hang yet: the catalogue index has not answered. The measured drawing is complete without it.'); return; }
      var raw = rows[ART.i % rows.length], row = normalize(raw);
      ART.raw = raw; ART.row = row; ART.url = imageUrl(row, raw, 700);
      var w = Math.round(clampN(box.clientWidth || 520, 260, 560));
      RM.render(cv, {
        scene: sc, artUrl: ART.url, widthIn: o.size[0], heightIn: o.size[1],
        frame: 'none', centerIn: o.center, gapIn: o.gap, minGapIn: 4, width: w, fit: true
      }).then(function (res) {
        LASTROOM = res;
        ART.ok = !!res.box;
        root.classList.toggle('wsz--noroom', !res.box);
        var cap = root.querySelector('[data-wsz-cap]');
        if (cap) {
          cap.innerHTML = '<a class="wsz-room__a" href="' + esc(pdpUrl(row, raw, o.size)) + '" data-wsz-cta="room-art">' +
            esc(row.title) + (row.artist ? ' <span>' + esc(row.artist) + '</span>' : '') + '</a>';
        }
        var note = root.querySelector('[data-wsz-roomnote]');
        if (note) {
          // The room is a stand-in with a measured wall, not a picture of the shopper's
          // furniture: the bed scenes are one photographed headboard for every bed size.
          // Say so, rather than let a king shopper read a queen bed as a promise.
          var stand = (ST.below === 'king' || ST.below === 'full')
            ? ' The bed in the photograph is a stand-in; your ' + R.below.label.toLowerCase() +
              ' is what the ' + Math.round(R.anchor) + ' in measurement uses.'
            : '';
          note.textContent = sizeLabel(o.size) + ' in ' + res.scene.label.toLowerCase() + ', drawn at true scale on a ' +
            Math.round(RM.wallWidthIn(res.scene)) + ' in wall.' + stand;
        }
        renderThumbs(R, sc, ART.url);
      }).catch(function () {
        roomOff('That painting could not be loaded. The measured drawing is complete without it.');
      });
    });
  }

  /* D5: the three options are three pictures of the same room, not three numbers */
  function renderThumbs(R, sc, url) {
    var RM = window.ArtSeeRoom;
    if (!RM || !sc) return;
    PICKS.forEach(function (k) {
      var cv = root.querySelector('[data-wsz-th="' + k + '"]');
      if (!cv) return;
      var x = R.options[k];
      var w = Math.round(clampN(cv.parentNode.clientWidth || 150, 90, 260));
      RM.render(cv, {
        scene: sc, artUrl: url, widthIn: x.size[0], heightIn: x.size[1],
        frame: 'none', centerIn: x.center, gapIn: x.gap, minGapIn: 4, width: w
      }).catch(function () { });
    });
  }

  /* ------------------------------------------------------------------- UI */
  function each(sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
  function on(el, is) { el.classList.toggle('is-on', !!is); el.setAttribute('aria-pressed', is ? 'true' : 'false'); }

  function syncView() {
    root.classList.toggle('wsz--draw', VIEW === 'draw');
    each('[data-wsz-view]', function (el) { on(el, el.getAttribute('data-wsz-view') === VIEW); });
  }

  function renderGrid(R) {
    var grid = root.querySelector('[data-wsz-grid]');
    var note = root.querySelector('[data-wsz-gridnote]');
    if (!grid) return;
    var sz = R.options[ST.pick].size;
    getRows(function (raws, live) {
      if (!raws || !raws.length) {
        grid.innerHTML = '';
        if (note) note.textContent = 'Paintings appear here as soon as the catalogue index loads.';
        return;
      }
      var html = raws.slice(0, 12).map(function (raw) {
        var row = normalize(raw);
        var wall = '/pages/see-art-on-your-wall#art=' + encodeURIComponent(row.handle) + '&size=' + sz[0] + 'x' + sz[1];
        return '<li class="wsz-card">' +
          '<a class="wsz-card__link" href="' + esc(pdpUrl(row, raw, sz)) + '" data-wsz-cta="product">' +
          '<span class="wsz-card__tile"><img loading="lazy" decoding="async" src="' + esc(imageUrl(row, raw, 400)) + '" alt="' + esc(row.title) + (row.artist ? ' by ' + esc(row.artist) : '') + '" width="400" height="400"></span>' +
          '<span class="wsz-card__t">' + esc(row.title) + '</span>' +
          '<span class="wsz-card__m">' + esc(row.artist || '') + '</span>' +
          '<span class="wsz-card__p">' + sizeLabel(sz) + (row.price > 0 ? ' · from ' + money(row.price) : '') + '</span>' +
          '</a>' +
          '<a class="wsz-card__wall" href="' + esc(wall) + '" data-wsz-cta="wall">See it on your wall</a>' +
          '</li>';
      }).join('');
      grid.innerHTML = html;
      if (note) note.textContent = raws.length + ' ' + OLBL[ST.o].toLowerCase() + ' paintings we paint at ' + sizeLabel(sz) +
        (live ? '' : ' · offline sample');
      var min = raws.reduce(function (m, raw) { var p = normalize(raw).price; return p > 0 ? Math.min(m, p) : m; }, Infinity);
      if (isFinite(min)) {
        each('.wsz-opt__p', function (el) { el.textContent = 'from ' + money(min); el.hidden = false; });
      }
    });
  }

  function renderStyles() {
    var box = root.querySelector('[data-wsz-styles]');
    if (!box || box.getAttribute('data-built') === '1') return;
    var styles = (META && META.styles) ? META.styles.slice(0, 8) : null;
    if (!styles) {
      var seen = {}, list = [];
      fallbackRows().forEach(function (r) { if (r.y && !seen[r.y]) { seen[r.y] = 1; list.push(r.y); } });
      styles = list.slice(0, 8);
    }
    if (!styles.length) { box.hidden = true; return; }
    box.hidden = false;
    box.innerHTML = '<span class="wsz-chips__lbl">Style</span>' +
      '<button type="button" class="wsz-chip" data-style="">Any</button>' +
      styles.map(function (s) { return '<button type="button" class="wsz-chip" data-style="' + esc(s) + '">' + esc(s) + '</button>'; }).join('');
    box.setAttribute('data-built', '1');
  }

  function render() {
    var R = compute();
    var o = R.options[ST.pick];

    [['below', ST.below], ['ceil', String(ST.c)], ['orient', ST.o], ['unit', ST.u], ['style', ST.style]]
      .forEach(function (pair) {
        each('[data-' + pair[0] + ']', function (el) { on(el, (el.getAttribute('data-' + pair[0]) || '') === pair[1]); });
      });

    var input = root.querySelector('[data-wsz-width]');
    if (input && document.activeElement !== input) input.value = round1(ST.w);
    var range = root.querySelector('[data-wsz-range]');
    if (range) {
      var lo = ST.u === 'cm' ? 60 : 24, hi = ST.u === 'cm' ? 460 : 180;
      range.min = lo; range.max = hi; range.step = ST.u === 'cm' ? 1 : 0.5;
      if (document.activeElement !== range) range.value = clampN(ST.w, lo, hi);
      range.setAttribute('aria-valuetext', round1(ST.w) + ' ' + ST.u);
    }
    var wlab = root.querySelector('[data-wsz-widthlabel]');
    if (wlab) wlab.textContent = R.isWall ? 'How wide is the wall?' : 'How wide is the ' + R.below.label.toLowerCase() + '?';
    var wunit = root.querySelector('[data-wsz-widthunit]');
    if (wunit) wunit.textContent = ST.u;

    var head = root.querySelector('[data-wsz-headline]');
    if (head) {
      head.innerHTML = 'Hang a <strong>' + sizeLabel(o.size) + '</strong> (' + sizeLabelCm(o.size) + ') ' +
        (R.isWall ? 'on your ' + Math.round(R.anchor) + '-inch wall' : 'above your ' + Math.round(R.anchor) + '-inch ' + R.below.label.toLowerCase()) +
        ', centred <strong>' + Math.round(o.center) + ' in</strong> (' + Math.round(cm(o.center)) + ' cm) from the floor.';
    }
    var why = root.querySelector('[data-wsz-why]');
    if (why) {
      var bits = [];
      bits.push(o.pct + '% of ' + (R.isWall ? 'the wall' : 'your ' + Math.round(R.anchor) + '-inch ' + R.below.label.toLowerCase()) +
        '. The calculator aimed at ' + Math.round(o.raw.w) + ' in and this is the nearest size we actually paint.');
      if (!R.isWall && o.gap != null) {
        var g = Math.round(o.gap), lo2 = R.below.gap[0], hi2 = R.below.gap[1];
        bits.push('Bottom edge lands ' + g + ' in above the ' + R.below.label.toLowerCase() +
          (g < lo2 ? '. Tighter than the usual ' + lo2 + '–' + hi2 + ' in, because the ceiling caps how high it can go.'
            : g > hi2 ? '. A touch more air than the usual ' + lo2 + '–' + hi2 + ' in.'
              : ', inside the usual ' + lo2 + '–' + hi2 + ' in.'));
      }
      if (o.aboveRule) bits.push('The centre sits above the 57–60 in museum rule on purpose: that rule is for an empty wall. With a ' +
        R.below.top + ' in ' + (R.below.art === 'bed' ? 'headboard' : R.below.art === 'mantel' ? 'mantel' : 'back') + ' below it, holding 57 in would put the painting inside the furniture.');
      bits.push('Hook at about ' + Math.round(o.hook) + ' in (' + Math.round(cm(o.hook)) + ' cm) from the floor. That is an estimate: it assumes a wire dropping about 3 in.');
      if (R.tooSmall) bits.push('Heads up: the smallest canvas we paint is ' + sizeLabel(SETS[ST.o][0]) + ', which is wider than what you entered.');
      else if (R.starved) bits.push('Your ' + ceilFt() + ' ft ceiling, not the ' + (R.isWall ? 'wall' : R.below.label.toLowerCase()) +
        ', is what limits this: a ' + OLBL[ST.o].toLowerCase() + ' canvas wide enough for the two-thirds rule would be taller than ' +
        Math.round(R.maxH) + ' in. Switch to Landscape, or plan a pair side by side.');
      else if (R.capped) bits.push('Bigger sizes were ruled out by your ' + ceilFt() + ' ft ceiling: nothing taller than ' + Math.round(R.maxH) + ' in.');
      why.innerHTML = bits.map(function (t) { return '<li>' + t + '</li>'; }).join('');
    }

    /* the drawing is regenerated at the width it will be displayed at, so 1 px is 1 px
       and 12 px type is 12 px; hidden behind the room tab it has no width of its own */
    var svg = root.querySelector('[data-wsz-svg]');
    if (svg) {
      var out = root.querySelector('[data-wsz-out]');
      var sw = svg.clientWidth || ((out ? out.clientWidth : 720) - 30);
      svg.innerHTML = elevation(R, sw);
    }

    var opts = root.querySelector('[data-wsz-options]');
    if (opts) {
      opts.innerHTML = PICKS.map(function (k) {
        var x = R.options[k], from = minPrice();
        return '<li><button type="button" class="wsz-opt' + (k === ST.pick ? ' is-on' : '') + '" data-pick="' + k + '" aria-pressed="' + (k === ST.pick) + '">' +
          '<span class="wsz-opt__th"><canvas data-wsz-th="' + k + '" width="150" height="150" aria-hidden="true"></canvas></span>' +
          '<span class="wsz-opt__k">' + PICK_LABEL[k] + '</span>' +
          '<span class="wsz-opt__s">' + sizeLabel(x.size) + '</span>' +
          '<span class="wsz-opt__c">' + sizeLabelCm(x.size) + '</span>' +
          '<span class="wsz-opt__p"' + (from ? '' : ' hidden') + '>' + (from ? 'from ' + money(from) : '') + '</span>' +
          '<span class="wsz-opt__w">' + x.pct + '% of the ' + (R.isWall ? 'wall' : R.below.label.toLowerCase()) + '</span>' +
          '</button></li>';
      }).join('');
    }

    renderRoom(R);
    renderStyles();
    renderGrid(R);
    syncView();
    writeHash();

    if (FIRST) { FIRST = false; track('tool_open', { below: ST.below }); }
    track('tool_result', { pick: ST.pick, size: o.size[0] + 'x' + o.size[1], below: ST.below, orientation: OLBL[ST.o] });
    return R;
  }

  function ceilFt() { return ST.c === 10 ? '10+' : String(ST.c); }

  function minPrice() {
    var rows = fallbackRows().filter(function (r) { return r.e === ORIENT[ST.o] && r.p > 0; });
    if (!rows.length) return 0;
    return rows.reduce(function (m, r) { return Math.min(m, r.p); }, Infinity);
  }

  function brief(R) {
    var o = R.options[ST.pick], L = [];
    L.push('WALL ART SIZE BRIEF (Art & See)');
    L.push('');
    L.push('Below the wall: ' + R.below.label + (R.isWall ? '' : ' (' + Math.round(R.anchor) + ' in / ' + Math.round(cm(R.anchor)) + ' cm wide)'));
    if (R.isWall) L.push('Wall width: ' + Math.round(R.anchor) + ' in / ' + Math.round(cm(R.anchor)) + ' cm');
    L.push('Ceiling: ' + ceilFt() + ' ft');
    L.push('Orientation: ' + OLBL[ST.o]);
    L.push('');
    L.push('Three sizes that fit:');
    PICKS.forEach(function (k) {
      var x = R.options[k];
      L.push('  ' + (k === ST.pick ? '> ' : '  ') + PICK_LABEL[k] + ': ' + sizeLabel(x.size) + ' (' + sizeLabelCm(x.size) + ') - ' + x.pct + '% of the ' + (R.isWall ? 'wall' : R.below.label.toLowerCase()));
    });
    L.push('');
    L.push('Hanging (' + PICK_LABEL[ST.pick] + '):');
    L.push('  Centre of the painting: ' + Math.round(o.center) + ' in / ' + Math.round(cm(o.center)) + ' cm from the floor');
    if (o.gap != null) L.push('  Gap above the ' + R.below.label.toLowerCase() + ': ' + Math.round(o.gap) + ' in / ' + Math.round(cm(o.gap)) + ' cm');
    L.push('  Hook: about ' + Math.round(o.hook) + ' in / ' + Math.round(cm(o.hook)) + ' cm from the floor (estimate, wire drops ~3 in)');
    L.push('');
    L.push('Reopen this result: ' + location.origin + location.pathname + location.hash);
    return L.join('\n');
  }

  /* B6: the drawing on one sheet of A4, with the numbers, to carry to the wall */
  function printPlan(R) {
    var box = root.querySelector('[data-wsz-print]');
    if (!box) return;
    var o = R.options[ST.pick];
    box.innerHTML = '<h2>Hanging plan · ' + esc(sizeLabel(o.size)) + ' ' + (R.isWall ? 'on an open wall' : 'above a ' + esc(R.below.label.toLowerCase())) + '</h2>' +
      '<div class="wsz-print__d">' + elevation(R, 980) + '</div>' +
      '<ul class="wsz-print__n">' +
      '<li><b>Painting</b> ' + esc(sizeLabel(o.size)) + ' (' + esc(sizeLabelCm(o.size)) + ')</li>' +
      '<li><b>Centre above floor</b> ' + Math.round(o.center) + ' in / ' + Math.round(cm(o.center)) + ' cm</li>' +
      (o.gap != null ? '<li><b>Gap above the ' + esc(R.below.label.toLowerCase()) + '</b> ' + Math.round(o.gap) + ' in / ' + Math.round(cm(o.gap)) + ' cm</li>' : '') +
      '<li><b>Hook</b> about ' + Math.round(o.hook) + ' in / ' + Math.round(cm(o.hook)) + ' cm (wire drops ~3 in)</li>' +
      '<li><b>' + (R.isWall ? 'Wall' : esc(R.below.label)) + '</b> ' + Math.round(R.anchor) + ' in wide · <b>Ceiling</b> ' + ceilFt() + ' ft</li>' +
      '</ul>' +
      '<p class="wsz-print__u">' + esc(location.origin + location.pathname + location.hash) + '</p>';
    track('tool_cta_click', { target: 'print' });
    window.print();
  }

  /* --------------------------------------------------------------- events */
  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-below],[data-ceil],[data-orient],[data-unit],[data-pick],[data-style],[data-wsz-view],[data-wsz-next],[data-wsz-print-go],[data-wsz-shuffle],[data-wsz-copy],[data-wsz-cta]') : null;
    if (!t) return;
    if (t.hasAttribute('data-wsz-cta')) { track('tool_cta_click', { target: t.getAttribute('data-wsz-cta') }); return; }
    e.preventDefault();
    if (t.hasAttribute('data-below')) {
      ST.below = t.getAttribute('data-below');
      var b = BELOW[ST.below];
      ST.w = ST.u === 'cm' ? Math.round(b.w * 2.54) : b.w;
      ST.o = b.o;
      ART.i = 0;
    } else if (t.hasAttribute('data-ceil')) ST.c = +t.getAttribute('data-ceil');
    else if (t.hasAttribute('data-orient')) { ST.o = t.getAttribute('data-orient'); ART.i = 0; }
    else if (t.hasAttribute('data-unit')) {
      var u = t.getAttribute('data-unit');
      if (u !== ST.u) { ST.w = u === 'cm' ? Math.round(ST.w * 2.54) : Math.round(ST.w / 2.54 * 10) / 10; ST.u = u; }
    }
    else if (t.hasAttribute('data-pick')) ST.pick = t.getAttribute('data-pick');
    else if (t.hasAttribute('data-wsz-view')) { VIEW = t.getAttribute('data-wsz-view'); syncView(); render(); return; }
    else if (t.hasAttribute('data-wsz-next')) { ART.i++; track('tool_cta_click', { target: 'another-painting' }); }
    else if (t.hasAttribute('data-wsz-print-go')) { printPlan(compute()); return; }
    else if (t.hasAttribute('data-style')) { ST.style = t.getAttribute('data-style') || ''; SEED = 1; ART.i = 0; }
    else if (t.hasAttribute('data-wsz-shuffle')) { SEED = (SEED * 1103515245 + 12345) >>> 0 || 1; ART.i = 0; track('tool_cta_click', { target: 'shuffle' }); }
    else if (t.hasAttribute('data-wsz-copy')) { copyBrief(t); return; }
    render();
  });

  /* the canvas is the painting: clicking it opens that painting at that size */
  var stage = root.querySelector('[data-wsz-canvas]');
  if (stage) stage.addEventListener('click', function () {
    if (!ART.row) return;
    track('tool_cta_click', { target: 'room-canvas' });
    location.href = pdpUrl(ART.row, ART.raw, compute().options[ST.pick].size);
  });

  root.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.hasAttribute) return;
    if (!el.hasAttribute('data-wsz-width') && !el.hasAttribute('data-wsz-range')) return;
    var n = parseFloat(el.value);
    if (!isFinite(n) || n <= 0) return;
    ST.w = n; render();
  });

  function copyBrief(btn) {
    var txt = brief(compute()), done = function () {
      var old = btn.getAttribute('data-label') || btn.textContent;
      btn.setAttribute('data-label', old); btn.textContent = 'Copied';
      setTimeout(function () { btn.textContent = old; }, 1800);
    };
    track('tool_cta_click', { target: 'copy_brief' });
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(txt).then(done, function () { legacyCopy(txt); done(); });
    } else { legacyCopy(txt); done(); }
  }
  function legacyCopy(txt) {
    var ta = document.createElement('textarea');
    ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.left = '-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) { }
    document.body.removeChild(ta);
  }

  window.addEventListener('hashchange', function () { readHash(); render(); });
  window.addEventListener('resize', function () { clearTimeout(RESIZE); RESIZE = setTimeout(render, 180); });

  readHash();
  render();

  if (window.ArtSeeCatalog && window.ArtSeeCatalog.meta) {
    Promise.resolve(window.ArtSeeCatalog.meta()).then(function (m) {
      META = m || null;
      var box = root.querySelector('[data-wsz-styles]');
      if (box) box.removeAttribute('data-built');
      renderStyles(); renderGrid(compute());
    }).catch(function () { });
  }

  /* measured, not asserted: the arithmetic behind the room view is readable */
  window.WSZDebug = {
    state: ST, compute: compute, room: function () { return LASTROOM; }, art: ART,
    scene: function () { return pickScene(compute()); }
  };
})();
